import { useRouter } from 'vue-router';
import _ from 'lodash';
import { Site, SLD } from '@patsnap-utils/biz';
import { Toast } from 'patsnap-biz';
import { useI18n } from 'vue-i18n';
import { openMessageBox } from '@eureka/confirm-box';
import { type HistoryItem } from '../types';
import { removeHistory, removeAllRecords } from '../infrastructure/api-functions';
import { CommonApis } from '@eureka/services/src/apis/common.api';
import { cn, tw, en, jp } from '../infrastructure/locales';
import { useNavBarState } from './use-navbar-store';
import { getPath, JUMP_PACKAGE, EVENTS_CONFIG, getHistoryTypeToMenuPath } from '../constants';

export const useNavBar = () => {
    const { t } = useI18n({
        messages: {
            cn, en, jp, tw,
        },
    });

    const router = useRouter();

    const { historyList, updateHistory } = useNavBarState();

    function confirmSaveBoardChange(data: { title?: string; content?: string } = {}) {
        return openMessageBox({
            title: data.title || t('NavBar.deleteTitle'),
            message: data.content || t('NavBar.deleteContent'),
            confirmButtonText: t('NavBar.confirm'),
            cancelButtonText: t('NavBar.cancel'),
        });
    }

    async function removeHistoryItem(data: HistoryItem, filters: string[] = []) {
        if (data.active) return;
        const confirm = await confirmSaveBoardChange()
        if (!confirm) return
        removeHistory(data, filters).then(() => {
            updateHistory(_.filter(historyList.value, nav => nav.id !== data.id));
            return Toast({
                message: t('NavBar.deleteSuccess'),
                type: 'success',
            });
        })
    }

    function track(type: string, detail: string) {
        CommonApis.track({
            event_type: type,
            event_detail_str: detail,
            module_type: 'EUREKA',
            source_type: 'air',
        })
    }

    function navigateTo(menu, packageName) {
        /**
         * 获取type对应的菜单路径
         */
        const typeBelongsTo = getHistoryTypeToMenuPath(menu.type);
        const name = _.get(window.location, 'pathname', '')?.replace(/\//g, '')?.toLowerCase();
        const path = getPath(menu.id, menu.type);

        if (menu.type && typeBelongsTo === name) {
            path && router.push({ path });
        } else if (packageName) {
            const url = `${new Site({ sld: SLD.EUREKA, pathname: packageName }).href}${path}`;
            window.open(url, '_self');
        }
    }

    function viewResult(menu) {
        const packageName = JUMP_PACKAGE[menu.type || menu.id];
        const event = EVENTS_CONFIG[menu.type || menu.id];

        track(event, menu.id);
        navigateTo(menu, packageName);
    }

    async function removeAllHistory(id: string) {
        track(EVENTS_CONFIG[id], id);
        const confirm = await confirmSaveBoardChange({
            title: t('NavBar.deleteAllTitle'),
            content: t('NavBar.deleteAllContent'),
        })
        if (!confirm) return
        removeAllRecords().then(() => {
            updateHistory([]);
            Toast({
                message: t('NavBar.deleteSuccess'),
                type: 'success',
            });
        })
    }

    return {
        viewResult,
        removeHistoryItem,
        removeAllHistory,
    }
}
